export const FETCH_PUBLISHED_NEWS = "fetch-published-news";
export const FETCH_MY_DRAFTS = "fetch-first-my-drafts";
export const LOAD_NEXT_MY_DRAFTS = "load-next-my-drafts";
export const SAVE_NEWS = "save-news";
export const CREATE_NEWS = "create-news";
export const OPEN_NEWS = "open-news";
export const DELETE_NEWS = "delete-news";
export const UPDATE_PICTURE_REFS = "update-picture-refs";
export const FETCH_MY_NEWS = "fetch-my-news";
